<template>
  <div class="client-eval-page--indiv">
    <div
      class="bgimg"
      :class="{ 'bgimg--indiv-full': indivPcBgimgUrl }"
      :style="indivBgimgStyle"
    >
      <div class="userlist client-eval-accounts">
        <div class="list_head">
          <div
            class="contnet pc-page"
            :style="{ height: pageMinHeight }"
          >
            <!-- 子路由：Main 布局 + 各面板（basic/orders/invoice/title） -->
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <ConsultFloatBar />
  </div>
</template>

<script>
/** 个人中心入口（from=indiv）：页面壳 + 子路由出口 */
import ConsultFloatBar from '@/components/consultFloatBar/index.vue';
import { VIEW_MODE } from './config';
import {
  refreshIndivSession,
  subscriptionState,
} from '@/view/user/indivSession/indivSessionService';
import vipbgimg from '@/components/header/img/vipbgimg.png';
import vipbgimgH from '@/components/header/img/vipbgimg-h.png';

export default {
  name: 'ClientPersonalCenter',
  components: {
    ConsultFloatBar,
  },
  mounted() {
    if (this.isIndivFrom) {
      refreshIndivSession({ store: this.$store });
    }
  },
  computed: {
    isIndivFrom() {
      return String(this.$route.query.from || '') === 'indiv';
    },
    /** 个人中心页壳背景：正式/预购 vipbgimg，试用中/到期 vipbgimg-h；未开通无背景 */
    indivPcBgimgUrl() {
      if (!this.isIndivFrom) return '';
      const mode = subscriptionState.view.mode;
      if (mode === VIEW_MODE.FORMAL) return vipbgimg;
      if (
        mode === VIEW_MODE.TRIAL ||
        mode === VIEW_MODE.TRIAL_EXPIRED ||
        mode === VIEW_MODE.EXPIRED
      ) {
        return vipbgimgH;
      }
      return '';
    },
    indivBgimgStyle() {
      if (!this.indivPcBgimgUrl) return {};
      return {
        backgroundImage: `url(${this.indivPcBgimgUrl})`,
      };
    },
    /** 内容区高度：全屏背景时贴合视口，避免出现页面级滚动条 */
    pageMinHeight() {
      if (this.indivPcBgimgUrl) {
        return 'calc(100vh - 120px)';
      }
      const base = document.documentElement.clientHeight - 141;
      return `${base + 20}px`;
    },
  },
};
</script>

<style src="./style.css"></style>



// WEBPACK FOOTER //
// src/view/client/personal-center/index.vue